
import useDodoneCollectionQuery from 'generated/api/dodones/useDodoneCollectionQuery'
import DodoneProofListItem from 'app/dodones/proofs/Trigger'
import Spinning from 'app/components/Spinning'
import DodonesList from 'app/dodones/list/Index'

const DodoablesDaysProofs = ({ dodone }) => {
  const { isPending, data: { dodones } = {} } = useDodoneCollectionQuery({
    path: `/api/dodones/${dodone.id}/proofs`
  })

  if(isPending) return <Spinning />

  return <div className="fcol flex-1">
           {
             window.currentIntent ?
               <div className="orange-transparent-box text-sm text-center px-d py-h mb-d">
                 Choose Target:
               </div> : null
           }
           <DodonesList
             dodones={ dodones }
             ListItemElement={ DodoneProofListItem } />
         </div>
}

export default DodoablesDaysProofs
